module.exports = __webpack_public_path__ + "static/img/no_good.679302d0.png";